import { useCallback, useState } from 'react';

import {
  Props,
  SectionState
} from '@/components/EpisodeOfCareSection/components/GraduateOrDischarge/types';
import { Color } from '@/constants/color';
import DischargeForm from '@/forms/DischargeForm';
import GraduateForm from '@/forms/GraduateForm';
import Button from '@/ui/components/Button';

const GraduateOrDischarge = ({ episodeOfCare, personId, setEditingProgramAndPhase }: Props) => {
  const [sectionState, setSectionState] = useState<SectionState>(SectionState.VIEWING);

  const renderSection = useCallback(() => {
    if (sectionState === SectionState.VIEWING) {
      return (
        <div className="space-x-1">
          <Button
            color={Color.EMERALD}
            onClick={() => setSectionState(SectionState.GRADUATING)}
            size="sm"
            type="button">
            Graduate
          </Button>

          <Button
            color={Color.RED}
            onClick={() => setSectionState(SectionState.DISCHARGING)}
            size="sm"
            type="button">
            Discharge
          </Button>
        </div>
      );
    }

    if (sectionState === SectionState.GRADUATING) {
      return (
        <div>
          <GraduateForm
            episodeOfCareId={episodeOfCare.id}
            personId={personId}
            onSuccess={() => {
              setEditingProgramAndPhase(false);
              setSectionState(SectionState.VIEWING);
            }}
          />

          <Button
            color={Color.WHITE}
            onClick={() => setSectionState(SectionState.VIEWING)}
            type="button">
            Cancel
          </Button>
        </div>
      );
    }

    if (sectionState === SectionState.DISCHARGING) {
      return (
        <div>
          <DischargeForm
            episodeOfCare={episodeOfCare}
            onSuccess={() => {
              setEditingProgramAndPhase(false);
              setSectionState(SectionState.VIEWING);
            }}
          />

          <Button
            color={Color.WHITE}
            onClick={() => setSectionState(SectionState.VIEWING)}
            type="button">
            Cancel
          </Button>
        </div>
      );
    }
  }, [episodeOfCare, personId, sectionState, setEditingProgramAndPhase]);

  return <div>{renderSection()}</div>;
};

export default GraduateOrDischarge;
